<template lang="pug">
  section.section.feedback#feedback
    SectionTitle(:text="title", number="5", isContrast)
    .container
      .row  
        .col-xs-12.col-sm-offset-1.col-sm-10.col-lg-offset-1.col-lg-5
          .feedback__contacts.contacts
            .contacts__text.text-body(v-fade)
              | Если у вас остались вопросы — напишите нам, мы с радостью ответим.
            .contacts__links(v-fade)
              a.contacts__mail(href="mailto:hello@villa-blanca.ru") hello@villa-blanca.ru
              .contacts__social-list.social-list
                a.contacts__social.social-list__item(href="https://vk.com/villablancaart", target="_blank")
                  img(src="~@/assets/vk.svg")
                a.contacts__social.social-list__item(href="https://www.instagram.com/villablancaart/", target="_blank")
                  img(src="~@/assets/insta.svg")
                a.contacts__social.social-list__item(href="https://www.facebook.com/villablancaart", target="_blank")
                  img(src="~@/assets/fb.svg")
        .col-xs-12.col-sm-offset-1.col-sm-10.col-lg-5.col-xl-5.col-xl-offset-0
          .feedback__form-container(v-fade)
            .feedback__result.text-body(v-if="form.isSent") Ваше сообщение отправлено. Спасибо!
            form.feedback__form.form.text-small(action="/process.php", v-if="!form.isSent", @submit.prevent="submit(form, form.url)")
              .form__group
                input.form__input(
                  type="text", id="text" name="emailaddress", required, title="Ваше имя", v-model="form.data[0].data", @blur="validateField()", data-warning="введите ваше имя", @focus="startInput()"
                )
                label.form__label(for="text") Имя
              .form__group
                input.form__input(
                  type="email", id="email" name="emailaddress", required, title="Ваш e-mail", v-model="form.data[1].data", @blur="validateField()", data-warning="укажите вашу почту", @focus="startInput()"
                )
                label.form__label(for="email") E-mail
              .form__group
                input.form__input(
                  type="tel", id="tel", name="phone", title="Телефон в формате 7 888 888-88-88", v-model="form.data[2].data", @blur="validateField()", data-warning="укажите ваш телефон", @focus="startInput()", maxlength="16"
                )
                label.form__label(for="tel") Телефон
              .form__group(id="age-input")
                input.form__input(
                  type="number", id="age", name="age", title="Ваш возраст", ref="age", 
                )
                label.form__label(for="age") Возраст
              .form__group
                textarea.form__input.form__input--textarea(
                  id="message" name="message" title="Сообщение" rows="5" cols="33", v-model="form.data[3].data", @blur="validateField()"
                )
                label.form__label(for="message") Сообщение
              button.button.button--contrast.button--wide(type="submit", :disabled="!form.isAgree") Отправить
              label.form__checkbox-label
                input.form__checkbox(type="checkbox", v-model="form.isAgree")
                span Соглашаюсь с 
                  a.form__link(href="/policy.pdf", target="_blank") условиями обработки персональных данных

</template>
<script>
import SectionTitle from "./SectionTitle.vue";
import Button from "./Button.vue";

export default {
  name: "Feedback",
  components: {
    SectionTitle,
    Button
  },
  data() {
    return {
      title: `Обратная связь`,
      form: {
        isAgree: false,
        subject: "Сообщение с сайта villa-blanca.ru",
        isSent: false,
        url: "/process.php",
        data: [
          {
            label: "Имя",
            data: ""
          },
          {
            label: "E-mail",
            data: ""
          },
          {
            label: "Телефон",
            data: ""
          },
          {
            label: "Сообщение",
            data: ""
          }
        ]
      }
    };
  },
  methods: {
    submit(form, url) {
      if (!this.$refs.age.value) {
        this.post(form, url, function(result) {
          if (result) {
            form.data.forEach(function(field) {
              field.data = "";
            });
            form.isSent = true;
            setTimeout(function() {
              form.isSent = false;
            }, 4000);
          }
        });
      }
    },
    post(data, url, success) {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, !0);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send(JSON.stringify(data));
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
          success(xhr.responseText);
        }
      };
    },
    validateField() {
      if (event.target.value) {
        event.target.classList.add("form__input--filled");
      } else if (!event.target.value && event.target.required) {
        event.target.classList.add("form__input--filled");
        event.target.classList.add("form__input--warning");
        event.target.value = event.target.dataset.warning;
      }
    },
    startInput() {
      if (event.target.value === event.target.dataset.warning) {
        event.target.value = "";
        event.target.classList.remove("form__input--warning");
      }
    }
  }
};
</script>

<style lang="scss">
@import "../styles/main.scss";

.feedback {
  margin-bottom: 50px;

  &__result {
    margin-top: 30px;
  }
}
.contacts {
  margin-top: 25px;

  &__text {
    margin-bottom: 30px;

    @include from("lg") {
      margin-bottom: 87px;
    }
  }
  &__mail {
    font-family: $font-fmbolyarpro;
    font-size: 26px;
    line-height: 34px;
    text-decoration: none;
    color: $color-text;
    transition: $links-hover-transition;

    &:hover {
      opacity: 0.8;
    }
  }
}
.form {
  margin-top: 30px;

  &__group {
    position: relative;
  }
  &__label {
    color: #b2b2b2;
    position: absolute;
    left: 12px;
    top: 7px;
    background: $color-background;
    z-index: 10;
    transition: $input-label-transition;
  }
  &__input {
    width: 100%;
    box-sizing: border-box;
    padding: 9px 14px 8px;
    border: 1px solid $color-text;
    margin-bottom: 18px;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
    border-radius: 0;

    &:focus ~ .form__label,
    &--filled ~ .form__label {
      transform: translateY(-80%);

      @include from("xxxl") {
        transform: translateY(-74%);
      }
    }

    &--warning {
      color: #fa7268;
    }
  }

  &__checkbox-label {
    font-size: 15px;
    line-height: 19px;
    color: #b2b2b2;
    margin-top: 7px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    @include from("xxxl") {
      margin-top: 15px;
      font-style: 20px;
    }
  }
  &__checkbox {
    margin-right: 3px;
  }
  &__link {
    color: #b2b2b2;
    text-decoration: none;
    transition: $links-hover-transition;

    &:hover {
      text-decoration: underline;
    }
  }
}
#age-input {
  display: none;
}
.social-list {
  margin-top: 17px;

  &__item {
    margin-right: 20px;
    transition: $links-hover-transition;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>